// extracted by mini-css-extract-plugin
module.exports = {"NumberContainer":"NumberInput_NumberContainer__2uxys","numberLabel":"NumberInput_numberLabel__99KEG"};